import { computed, inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { OidcSecurityService, type UserDataResult } from 'angular-auth-oidc-client';

export interface UserClaims {
  name: string;
  jobTitle: string;
}

type OidcClaims = Readonly<{
  name?: string;
  given_name?: string;
  family_name?: string;
  preferred_username?: string;
  jobTitle?: string;
  job_title?: string;
  title?: string;
}>;

@Injectable()
export class UserService {
  private readonly oidc: OidcSecurityService = inject(OidcSecurityService);

  private readonly userData: Signal<UserDataResult | undefined> = toSignal(this.oidc.userData$);

  readonly name: Signal<string> = computed((): string => toName(this.claims()));

  readonly jobTitle: Signal<string> = computed((): string => toJobTitle(this.claims()));

  private claims(): OidcClaims | null {
    return (this.userData()?.userData as OidcClaims | null | undefined) ?? null;
  }
}

function toName(claims: OidcClaims | null): string {
  if (claims === null) return '';
  if (claims.name !== undefined && claims.name !== '') return claims.name;
  const composed: string = [claims.given_name, claims.family_name]
    .filter((part: string | undefined): part is string => part !== undefined && part !== '')
    .join(' ');
  if (composed !== '') return composed;
  return claims.preferred_username ?? '';
}

function toJobTitle(claims: OidcClaims | null): string {
  if (claims === null) return '';
  return claims.jobTitle ?? claims.job_title ?? claims.title ?? '';
}
